export default {
    primary: '#3a526a',
    secondary: '#2e363a',
    accent: '#007aff',
    complementary: '#FF8500',
}
